// extracted by mini-css-extract-plugin
export default {"bounce":"N_dG","loading":"N_dH","logo-mark-bounce-right":"N_dJ","logo-mark-bounce-left":"N_dK"};